export default __webpack_public_path__ + "static/media/IMG-20241005-WA0017.b6ae472b.jpg";